import React from 'react';

const YahooMailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px">
    <path
      fill="#5c6bc0"
      d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5	V37z"
    />
    <path
      fill="#fff"
      d="M34,13H14c-0.552,0-1,0.448-1,1v12c0,0.552,0.448,1,1,1h20c0.552,0,1-0.448,1-1V14	C35,13.448,34.552,13,34,13z M33,17l-9,4l-9-4v-2h18V17z"
    />
    <g transform="matrix(.63072 0 0 .63072 -72.063 127.866)">
      <path
        fill="#fff"
        d="M132.266-150.491h2.385l1.389,3.552l1.407-3.552h2.322l-3.496,8.41h-2.337 l0.957-2.228L132.266-150.491z"
      />
      <path
        fill="#fff"
        d="M142.186-150.633c-1.792,0-2.924,1.607-2.924,3.207c0,1.801,1.242,3.228,2.89,3.228 c1.23,0,1.693-0.749,1.693-0.749v0.584h2.08v-6.128h-2.08v0.557C143.846-149.934,143.328-150.633,142.186-150.633z M142.629-148.663c0.827,0,1.253,0.654,1.253,1.244c0,0.636-0.457,1.259-1.253,1.259c-0.66,0-1.256-0.539-1.256-1.232 C141.372-148.095,141.852-148.663,142.629-148.663z"
      />
      <path
        fill="#fff"
        d="M146.642-144.363v-8.834h2.175v3.284c0,0,0.517-0.719,1.599-0.719 c1.324,0,2.099,0.986,2.099,2.396v3.873h-2.159v-3.343c0-0.477-0.227-0.938-0.742-0.938c-0.524,0-0.797,0.468-0.797,0.938v3.343 H146.642z"
      />
      <path
        fill="#fff"
        d="M156.224-150.632c-2.052,0-3.274,1.56-3.274,3.232c0,1.902,1.479,3.203,3.281,3.203 c1.747,0,3.275-1.241,3.275-3.171C159.507-149.479,157.907-150.632,156.224-150.632z M156.244-148.645 c0.725,0,1.226,0.604,1.226,1.247c0,0.549-0.467,1.226-1.226,1.226c-0.695,0-1.217-0.558-1.217-1.232 C155.027-148.053,155.46-148.645,156.244-148.645z"
      />
      <path
        fill="#fff"
        d="M163.131-150.632c-2.052,0-3.274,1.56-3.274,3.232c0,1.902,1.479,3.203,3.281,3.203 c1.747,0,3.275-1.241,3.275-3.171C166.414-149.479,164.814-150.632,163.131-150.632z M163.151-148.645 c0.725,0,1.226,0.604,1.226,1.247c0,0.549-0.467,1.226-1.226,1.226c-0.695,0-1.217-0.558-1.217-1.232 C161.933-148.053,162.367-148.645,163.151-148.645z"
      />
      <circle cx="168.131" cy="-145.677" r="1.445" fill="#fff" />
      <path fill="#fff" d="M170.05-147.653h-2.601l2.308-5.545h2.591L170.05-147.653z" />
    </g>
  </svg>
);

export default YahooMailIcon;
